import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import {environment} from "../../../environments/environment";

@Injectable()
export class HttpResponseInterceptor implements HttpInterceptor {

  constructor(
    private _toastr: ToastrService
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (event.status === 204) {

            this._toastr.success('Met succes verwijderd!', 'Success', {
              timeOut: environment.TOASTER_TIMEOUT,
              positionClass: environment.TOASTER_POSITION
            });
          }
          event = event.clone({
            body: event.body !== null ? event.body.data : ''
          })
        }
        return event;
      })
    )
  }
}
